module.exports = new __parcel__URL__("../iconoIFNpushed.6674fb99.svg").toString();